import './demo-showcase.css'

import PropTypes from 'prop-types'
import { useState } from 'react'

import { writeParam } from '../../i18n'
import ShowStory from '../stage/ShowStory'
import { BranchPicker, BranchProvider, readBranch } from './branch'
import { SHOW_DEMO_COPY } from './copy'
import DmsAnalyse, { ANALYSE_PARTICLES } from './scenes/DmsAnalyse'
import DmsCases, { CASES_PARTICLES } from './scenes/DmsCases'
import DmsClose, { CLOSE_PARTICLES } from './scenes/DmsClose'
import DmsIntro, { INTRO_PARTICLES } from './scenes/DmsIntro'
import DmsLever, { LEVER_PARTICLES } from './scenes/DmsLever'
import DmsPerspectives, {
  PERSPECTIVE_PARTICLES
} from './scenes/DmsPerspectives'
import DmsProblem, { PROBLEM_PARTICLES } from './scenes/DmsProblem'
import DmsProcess, { PROCESS_PARTICLES } from './scenes/DmsProcess'
import DmsScience, { SCIENCE_PARTICLES } from './scenes/DmsScience'
import DmsScore, { SCORE_PARTICLES } from './scenes/DmsScore'
import DmsSteps, { STEPS_PARTICLES } from './scenes/DmsSteps'
import DmsTesting, { TESTING_PARTICLES } from './scenes/DmsTesting'

/**
 * Use Case „Produkt-Demo“ als Showcase: das Demo-Deck 2026 als Scrollstory
 * mit durchgehendem Partikelfeld, echten Clips und Branchen-Personalisierung.
 */
const SECTIONS = [
  {
    id: 'intro',
    height: 420,
    glow: ['#407BFF', '#43DBBD'],
    particles: INTRO_PARTICLES,
    Scene: DmsIntro
  },
  {
    id: 'problem',
    height: 520,
    glow: ['#2D45A0', '#43DBBD'],
    particles: PROBLEM_PARTICLES,
    Scene: DmsProblem
  },
  {
    id: 'hebel',
    height: 480,
    glow: ['#FE79A7', '#407BFF'],
    particles: LEVER_PARTICLES,
    Scene: DmsLever
  },
  {
    id: 'schritte',
    height: 420,
    glow: ['#FFB628', '#407BFF'],
    particles: STEPS_PARTICLES,
    Scene: DmsSteps
  },
  {
    id: 'analyse',
    height: 420,
    glow: ['#407BFF', '#8FB0FF'],
    particles: ANALYSE_PARTICLES,
    Scene: DmsAnalyse
  },
  {
    id: 'testung',
    height: 820,
    glow: ['#43DBBD', '#FE79A7'],
    particles: TESTING_PARTICLES,
    Scene: DmsTesting
  },
  {
    id: 'perspektiven',
    height: 520,
    glow: ['#FFB628', '#FE79A7'],
    particles: PERSPECTIVE_PARTICLES,
    Scene: DmsPerspectives
  },
  {
    id: 'matching',
    height: 620,
    glow: ['#407BFF', '#43DBBD'],
    particles: SCORE_PARTICLES,
    Scene: DmsScore
  },
  {
    id: 'prozess',
    height: 480,
    glow: ['#43DBBD', '#2D45A0'],
    particles: PROCESS_PARTICLES,
    Scene: DmsProcess
  },
  {
    id: 'wissenschaft',
    height: 380,
    tone: 'blue',
    glow: ['#8FB0FF', '#43DBBD'],
    particles: SCIENCE_PARTICLES,
    Scene: DmsScience
  },
  {
    id: 'faelle',
    height: 640,
    glow: ['#FE79A7', '#407BFF'],
    particles: CASES_PARTICLES,
    Scene: DmsCases
  },
  {
    id: 'abschluss',
    height: 460,
    glow: ['#FE79A7', '#FFB628'],
    particles: CLOSE_PARTICLES,
    Scene: DmsClose
  }
]

export default function DemoShowcase({ theme = 'dark' }) {
  const [branch, setBranch] = useState(readBranch)

  const choose = (id) => {
    writeParam('branche', id === 'allgemein' ? null : id)
    setBranch(id)
  }

  return (
    <BranchProvider value={branch}>
      <ShowStory
        sections={SECTIONS}
        copy={SHOW_DEMO_COPY}
        theme={theme}
        navExtra={<BranchPicker value={branch} onChange={choose} />}
      />
    </BranchProvider>
  )
}

DemoShowcase.propTypes = { theme: PropTypes.oneOf(['dark', 'light']) }

export const DemoShowcaseLight = () => <DemoShowcase theme='light' />
